import { Link } from "react-router-dom";
import HelpArticle, { type HelpArticleText } from "../HelpArticle";

// Run E2 J2: rewritten for Project Explore (K-5), English and Spanish.

const TEXT: Record<"en" | "es", HelpArticleText> = {
  en: {
    title: "Logging In as a Student or Teacher",
    intro: "Teachers and students use the same login page.",
    steps: [
      <>
        Go to the{" "}
        <Link to="/login-portal" className="text-indigo-700 underline">
          login page
        </Link>
        .
      </>,
      "Sign in with Google, with Clever, or with your email and password.",
      "Teachers go to the teacher dashboard.",
      "Students go to My Learning Dashboard, where their assigned chapters are listed.",
    ],
    tip: "Forgot your password? Use the forgot password link on the login page.",
  },
  es: {
    title: "Cómo iniciar sesión como estudiante o maestro",
    intro: "Los maestros y los estudiantes usan la misma página para iniciar sesión.",
    steps: [
      <>
        Ve a la{" "}
        <Link to="/login-portal" className="text-indigo-700 underline">
          página para iniciar sesión
        </Link>
        .
      </>,
      "Inicia sesión con Google, con Clever o con tu correo electrónico y tu contraseña.",
      "Los maestros entran a su panel de maestro.",
      "Los estudiantes entran a Mi panel de aprendizaje, donde ven los capítulos que tienen asignados.",
    ],
    tip: "¿Olvidaste tu contraseña? Usa el enlace para recuperar la contraseña en la página para iniciar sesión.",
  },
};

export default function LoggingInAsStudentOrTeacher() {
  return <HelpArticle text={TEXT} />;
}
